import { ChangeDetectionStrategy, Component, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'shell-facetec-video',
  templateUrl: './facetec-video-modal.component.html',
  styleUrls: ['./facetec-video-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacetecVideoModalComponent {
  readonly title = 'Video instructivo';

  constructor(public dialogRef: MatDialog, public ngZone: NgZone) {}

  closeModal() {
    this.ngZone.run(() => {
      this.dialogRef.closeAll();
    });
  }
}
